import { Text } from "@meditect/medibase-components";

export const UserEmailAlreadyExistsError = (): React.ReactElement => {
  return <Text>Cette adresse e-mail est déjà utilisée par un autre utilisateur</Text>;
};
